import mitt from 'mitt';
const emitter = mitt();

// Global event bus 🚌
export default emitter;
